import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@clerk/react";
import { createCreditsApi } from "@/lib/api/credits";
import type {
  BalanceResponse,
  TransactionListParams,
  TransactionListResponse,
} from "@/lib/api/credits";

export const CREDITS_BALANCE_QUERY_KEY = ["credits-balance"] as const;

export function useCreditsBalance() {
  const { getToken, isSignedIn } = useAuth();

  return useQuery<BalanceResponse>({
    queryKey: CREDITS_BALANCE_QUERY_KEY,
    queryFn: () => {
      const api = createCreditsApi({ getToken });
      return api.getBalance();
    },
    enabled: !!isSignedIn,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}

export const TRANSACTIONS_QUERY_KEY = ["credit-transactions"] as const;

export function useTransactions(params: TransactionListParams = {}) {
  const { getToken, isSignedIn } = useAuth();

  return useQuery<TransactionListResponse>({
    queryKey: [...TRANSACTIONS_QUERY_KEY, params],
    queryFn: () => {
      const api = createCreditsApi({ getToken });
      return api.getTransactions(params);
    },
    enabled: !!isSignedIn,
    staleTime: 30_000,
  });
}
